import script from "./ReportRegistroAsistencia.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportRegistroAsistencia.vue?vue&type=script&setup=true&lang=js"

import "./ReportRegistroAsistencia.vue?vue&type=style&index=0&id=3ec531cf&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec531cf"]])

export default __exports__